import { render, staticRenderFns } from "./chargesSatistics.vue?vue&type=template&id=9c0958b2&"
import script from "./chargesSatistics.vue?vue&type=script&lang=js&"
export * from "./chargesSatistics.vue?vue&type=script&lang=js&"
import style0 from "./chargesSatistics.vue?vue&type=style&index=0&lang=css&"
import style1 from "./chargesSatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "chargesSatistics.vue"
export default component.exports